import React, { useState, useEffect } from "react";
import AdditionaLInfoPage from "../../../../../../entities/DashboardPage/HRModule/Employees/Add/AdditionalInfo";
import AuthService from "../../../../../../api/AuthService";
import LoaderHelper from "../../../../../../utils/Loader/LoaderHelper";
import { useLocation } from "react-router-dom";
import { useAlert } from "../../../../../../context/AlertContext";
import { set } from "react-hook-form";

const AdditionaLInfo = () => {
  const { state } = useLocation();
  const { userData, oneEmloyeeData } = state || {};

  useEffect(() => {
    getAllowanceType();
    getFringeType();
    getLeviesType();
    getAllowance();
    getFringeBenefits();
    getLevies();
    getMedical();
    getPension();
    getPensionType();
    getContributionsType();
    getContributionsdata();
    getCreditsType();
    getEmployeeList();
    getAllCredits();
    getSingleCreditTypeId();
    getTaxRulesAvailable();
    getLeaveTypes();
  }, []);

  const [pensionType, setPensionType] = useState([]);
  const [pension, setPension] = useState([]);
  const [contributions, setContributions] = useState([]);
  const [allowanceType, setAllowanceType] = useState([]);
  const [fringeType, setFringeType] = useState([]);
  const [leviesType, setLeviesType] = useState([]);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [allowance, setAllowance] = useState([]);
  const [fringeBenefit, setFringeBenefit] = useState([]);

  const [levies, setLevies] = useState([]);
  const [medical, setMedical] = useState([]);

  const [creditsType, setCreditsType] = useState([]);
  const [credits, setCredits] = useState([])

  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [contributionType, setContributionsType] = useState([])
  const [singleCreditTypes, setSingleCreditTypes] = useState([])
  const [taxRulesListData, setTaxRulesListData] = useState([])
  const [leaveTypes, setLeaveTypes] = useState([])
  const [employeeLeaves, setEmployeeLeaves] = useState([])
  const [employeeBeneficiaryValues, setEmployeeBeneficiaryValues] = useState({})


  const getAllowanceType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAllowanceType();
      if (result?.success) {
        setAllowanceType(result?.data?.allowance);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getFringeType = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getFringeType();
      if (result?.success) {
        setFringeType(result?.data?.fringes);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getLeviesType = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getLeviesType();
      if (result?.success) {
        setLeviesType(result?.data?.levies);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getAllowance = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getEmpAllowance(userData?._id);
      if (result?.success) {
        setAllowance(result?.data?.allowances ?? []);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getFringeBenefits = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getEmpFringeBenefits(userData?._id);
      console.log(result, "116 result");
      if (result?.success) {
        const fringeBenefit = result?.data?.[0]?.fringeB || [];
        const newFringe = (fringeBenefit || []).map((levy) => {
          const { isTaxable, amount, ...rest } = levy || {};
          return { ...rest, _id: levy?._id };
        });
        setFringeBenefit(newFringe);
        LoaderHelper.loaderStatus(false);
      } else {                                                                                          
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getLevies = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getEmpLevies(userData?._id);
      if (result?.success) {
        const leviesArr = result?.data?.levies || [];
        const newLevies = (leviesArr || []).map((levy) => {
          const { isTaxable, payType, deductType, rateValue, ...rest } = levy || {};
          return { ...rest, _id: levy?._id };
        });
        setLevies(newLevies);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getMedical = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getEmpMedical(userData?._id);
      if (result?.success) {
        setMedical(result?.data ?? []);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getPension = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getEmpPension(userData?._id);
      if (result?.success) {
        // if (result?.data?.length > 0) {
        setPension(result?.data?.[0]?.contributions ?? []);

        // }
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handlePension = async (data) => {
    setLoading(true);
    try {
      const result = await AuthService.handleEmpPension(userData?._id, data);
      if (result?.success) {
        setLoading(false);
        getPension();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "success");
    }
  };
  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteEmpPension(id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        getPension();
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getPensionType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPensionType();
      if (result?.success) {
        setPensionType(result?.data);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleAllowance = async (payload) => {
    setLoading(true);
    try {
      const result = await AuthService.handleEmpAllowance(payload, userData?._id);
      if (result?.success === true) {
        setLoading(false);

        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "success");
    }
  };
  const handleLevies = async (data) => {
    setLoading(true);
    try {
      const result = await AuthService.handleEmpLevie(data, userData?._id);
      if (result?.success === true) {
        setLoading(false);

        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "success");
    }
  };
  const handleFringeBenefit = async (payload) => {
    setLoading(true);
    try {
      const result = await AuthService.handleEmpFringeBenefit(
        payload,
        userData?._id
      );
      if (result?.success === true) {
        setLoading(false);

        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "success");
    }
  };
  const handleMedical = async (data) => {
    setLoading(true);
    try {
      const result = await AuthService.handleEmpMedical(data, userData?._id);
      if (result?.success === true) {
        setLoading(false);
        getMedical();

        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "success");
    }
  };

  const getContributionsdata = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getContributions(userData?._id);
      if (result?.success) {
        setContributions(result?.data?.[0]?.contributions ?? []);

        // }
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleContributions = async (data) => {
    setLoading(true);
    try {

      const result = await AuthService.handleContributions(userData?._id, data);
      if (result?.success) {
        setLoading(false);
        getContributionsdata();
        // Call credit API after successful contribution add
        await getAllCredits();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message || JSON.stringify(error), "error");
    }
  };
  const handleDeleteContributions = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteContributions(id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);

        getContributionsdata();
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getContributionsType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getContributionsType();
      if (result?.success) {
        setContributionsType(result?.data?.contributions);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getCreditsType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getCreditsType();
      if (result?.success) {
        setCreditsType(result?.data?.credits);
        LoaderHelper.loaderStatus(false);
        // getCredits()
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleCredits = async (data) => {
    setLoading(true);
    try {
      const result = await AuthService.addEmployeeCredits(data, userData?._id);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "success");
    }
  };

  const handleDeleteCredits = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteEmployeeCredits(id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success")
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error")
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getEmployeeList = async (text = "", page = 1, sort = "", getFilterVaue = "", type = "all") => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getEmployeeList(text, page, sort, getFilterVaue, type);
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getAllCredits = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.fetchCredits(userData?._id);
      setCredits(result?.data)
      if (result?.success && result?.data) {
        // Fetch employee beneficiary values for all credits
        const values = {};
        for (const credit of result.data) {
          try {
            const beneficiaryResult = await AuthService.getCreditBeneficiaries(credit._id);
            if (beneficiaryResult?.success && beneficiaryResult?.data?.beneficiaries) {
              const employeeBeneficiary = beneficiaryResult.data.beneficiaries.find(
                b => b.beneficiary_type === "Employee"
              );
              values[credit._id] = employeeBeneficiary?.value || 0;
            } else {
              values[credit._id] = 0;
            }
          } catch (error) {
            values[credit._id] = 0;
          }
        }
        setEmployeeBeneficiaryValues(values);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleCreditApply = async (data) => {
    setLoading(true);
    try {
      const result = await AuthService.handleCreditApply(data?.isApplicable, data?.creditId);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "success");
    }
  };

  const getAllBenificiaries = async (id) => {
    setBeneficiaries([]);
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.fetchBenificiaries(userData?._id, id);
      if (result?.success && result?.data) {
        setBeneficiaries(Array.isArray(result.data) ? result.data : []);
      } else {
        setBeneficiaries([]);
      }
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      setBeneficiaries([]);
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleBeneficiarySaved = async (data) => {
    setLoading(true);
    try {
      // Filter out beneficiaries with realtionship "Employee"
      const filteredData = {
        ...data,
        credit_beneficiary: (data.credit_beneficiary || []).filter(
          (beneficiary) => beneficiary.realtionship !== "Employee"
        )
      };
      const result = await AuthService.addNewEmployeeCredits(filteredData);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "success");
    }
  };

  const handleUpdateBeneficiary = async (data) => {
    setLoading(true);
    try {
      // Filter out beneficiaries with realtionship "Employee"
      const filteredData = {
        ...data,
        credit_beneficiary: (data.credit_beneficiary || []).filter(
          (beneficiary) => beneficiary.realtionship !== "Employee"
        )
      };
      const result = await AuthService.updateBeneficiaryCredits(filteredData);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
        // getAllBenificiaries();
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "success");
    }
  };

  const handleDeleteBeneficiary = async (id, creditId) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleDeletBeneficiary(id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success")
        // Immediately fetch beneficiaries list if creditId is provided
        if (creditId && typeof getAllBenificiaries === "function") {
          await getAllBenificiaries(creditId);
        }
        // Refresh credits list in AdditionalInfo
        await getAllCredits();
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error")
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  }

  const handleAllContribution = async (data) => {
    if (!data) return;
    const { kind, payload } = data;
    try {
      switch (kind) {
        case "allowances":
          await handleAllowance(payload);
          // Refresh allowances data after a short delay to ensure API completes
          setTimeout(() => {
            getAllowance();
          }, 500);
          break;

        case "fringeB":
          await handleFringeBenefit(payload);
          // Refresh fringe benefits data after a short delay
          setTimeout(() => {
            getFringeBenefits();
          }, 500);
          break;

        case "levies":
          await handleLevies(payload);
          // Refresh levies data after a short delay
          setTimeout(() => {
            getLevies();
          }, 500);
          break;

        case "contributions":
          await handleContributions(payload);
          // handleContributions already calls getContributionsdata()
          break;

        default:
          break;
      }
    } catch (error) {
      console.error("Error in handleAllContribution:", error);
    }
  };

  const handleContributionDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.removeEmpContribution(userData?._id, id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        getContributionsdata();
        showAlert(result?.message || "Contribution deleted successfully", "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message || "Failed to delete contribution", "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message || "An error occurred", "error");
    }
  };

  const handleAllowancesDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.removeEmpAllowance(userData?._id, id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        getAllowance();
        showAlert(result?.message || "Allowance deleted successfully", "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message || "Failed to delete allowance", "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message || "An error occurred", "error");
    }
  };

  const handleFringeBenefitsDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.removeEmpFringeBenefit(userData?._id, id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        getFringeBenefits();
        showAlert(result?.message || "Fringe benefit deleted successfully", "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message || "Failed to delete fringe benefit", "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message || "An error occurred", "error");
    }
  };

  const handleLeviesDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.removeEmpLevy(userData?._id, id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        getLevies();
        showAlert(result?.message || "Levy deleted successfully", "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message || "Failed to delete levy", "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message || "An error occurred", "error");
    }
  };

  const handlePostCreditApply = async (data) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.postCreditApply(data);
      if (result?.success === true) {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "error");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      showAlert(error, "success");
      LoaderHelper.loaderStatus(false);
    }
  };
  const getSingleCreditTypeId = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getSingleCreditTypeId(userData?._id);
      setSingleCreditTypes(result?.data);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getTaxRulesAvailable = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getEmployeeTaxRulesAvailable(userData?._id);
      if (result?.success) {
        const taxRules = result?.data || [];
        setTaxRulesListData(taxRules);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleTaxRuleApply = async (payload) => {
    setLoading(true);
    try {
      const result = await AuthService.handleEmployeeTaxRules(payload);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message || "Tax rule updated successfully", "success");
        await getTaxRulesAvailable();
      } else {
        setLoading(false);
        showAlert(result?.message || "Failed to update tax rule", "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message || "An error occurred", "error");
      throw error;
    }
  };

  const refreshTaxRules = async () => {
    await getTaxRulesAvailable();
  };

  const getLeaveTypes = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAccountLeaveType();
      if (result?.success) {
        setLeaveTypes(result?.data || []);
        LoaderHelper.loaderStatus(false);
        await getEmployeeLeaveBalances();
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getEmployeeLeaveBalances = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getEmployeeLeaveBalances({
        employee: userData?._id,
        page: 1,
        limit: 10,
      });
      if (result?.success) {
        const leavesData = result?.data?.leaveBalances || result?.data || [];
        setEmployeeLeaves(leavesData);
        LoaderHelper.loaderStatus(false);
      } else {
        setEmployeeLeaves([]);
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      setEmployeeLeaves([]);
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleLeaveBalanceCreate = async (payload) => {
    setLoading(true);
    try {
      const result = await AuthService.createEmployeeLeaveBalance(payload);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message || "Leave balance created successfully", "success");
        await getEmployeeLeaveBalances();
      } else {
        setLoading(false);
        showAlert(result?.message || "Failed to create leave balance", "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message || "An error occurred", "error");
      throw error;
    }
  };

  const handleLeaveBalanceUpdate = async (id, payload) => {
    setLoading(true);
    try {
      const result = await AuthService.updateEmployeeLeaveBalance(id, payload);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message || "Leave balance updated successfully", "success");
        await getEmployeeLeaveBalances();
      } else {
        setLoading(false);
        showAlert(result?.message || "Failed to update leave balance", "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message || "An error occurred", "error");
      throw error;
    }
  };

  const handleLeaveBalanceDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteEmployeeLeaveBalance(id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        getEmployeeLeaveBalances();
        showAlert(result?.message || "Leave balance deleted successfully", "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message || "Failed to delete leave balance", "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message || "An error occurred", "error");
    }
  };

  const refreshLeaves = async () => {
    await getEmployeeLeaveBalances();
  };


  return (
    <AdditionaLInfoPage
      handleMedical={handleMedical}
      handleAllowance={handleAllowance}
      handleLevies={handleLevies}
      handleFringeBenefit={handleFringeBenefit}
      allowanceType={allowanceType}
      fringeType={fringeType}
      leviesType={leviesType}
      getAllowance={allowance}
      getFringeBenefit={fringeBenefit}
      getLevies={levies}
      getMedical={medical}
      loading={loading}
      getPension={pension}
      handlePension={handlePension}
      pensionType={pensionType}
      handleDelete={handleDelete}
      getContributionsdata={contributions}
      handleContributions={handleContributions}
      handleDeleteContributions={handleDeleteContributions}
      contributionType={contributionType}
      creditsListData={credits}
      creditsType={creditsType}
      handleCreditsData={handleCredits}
      handleDeleteCredits={handleDeleteCredits}
      userData={userData}
      // getCredits={getCredits}
      oneEmloyeeData={oneEmloyeeData}
      handleCreditApply={handleCreditApply}
      handleBeniSaved={handleBeneficiarySaved}
      handleUpdateBeneficiary={handleUpdateBeneficiary}
      beneficiaries={beneficiaries}
      handleDeleteBeneficiary={handleDeleteBeneficiary}
      getAllBenificiaries={getAllBenificiaries}
      handleAllContribution={handleAllContribution}
      handleContributionDelete={handleContributionDelete}
      handleAllowancesDelete={handleAllowancesDelete}
      handleFringeBenefitsDelete={handleFringeBenefitsDelete}
      handleLeviesDelete={handleLeviesDelete}
      handlePostCreditApply={handlePostCreditApply}
      getAllCredits={getAllCredits}
      singleCreditTypes={singleCreditTypes}
      employeeBeneficiaryValues={employeeBeneficiaryValues}
      taxRulesListData={taxRulesListData}
      handleTaxRuleApply={handleTaxRuleApply}
      refreshTaxRules={refreshTaxRules}
      getLeaves={employeeLeaves}
      handleLeaveBalanceCreate={handleLeaveBalanceCreate}
      handleLeaveBalanceUpdate={handleLeaveBalanceUpdate}
      refreshLeaves={refreshLeaves}
      handleLeaveBalanceDelete={handleLeaveBalanceDelete}
    />
  );
};

export default AdditionaLInfo;
